<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Premies voor arbeidsongeschiktheidsverzekeringen
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Betaal je premies voor particuliere arbeidsongeschiktheidsverzekeringen die je recht geven op periodieke
                uitkeringen bij invaliditeit, ziekte of ongeval? Dan mag je deze volledig aftrekken. Het gaat
                bijvoorbeeld om verzekeringen voor het opvullen van het WIA-gat (Wet werk en Inkomen naar
                Arbeidsvermogen).
                <div class="space10"></div>

                Het gaat niet om:
                <li class="list">premies waarmee je werkgever rekening houdt bij het inhouden van de loonheffing</li>
                <li class="list">premies voor de verplichte verzekeringen Ziektewet en WIA</li>
                <li class="list">premies voor verzekeringen die een bedrag ineens uitkeren, zoals kapitaalverzekeringen</li>
                <li class="list">premies voor de Zorgverzekeringswet</li>

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Lijfrentepremies voor een meerderjarig invalide (klein)kind
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Heb je premies betaald voor een lijfrenteverzekering waarvan de uitkeringen toekomen aan je
                meerderjarige invalide (klein)kind? Dan mag je deze volledig aftrekken als de uitkeringen aan de
                volgende voorwaarden voldoen:

                <li class="list">de uitkeringen zijn bestemd voor het levensonderhoud van het (klein)kind overeenkomstig zijn plaats
                    in de samenleving. De plaats in de samenleving wordt onder meer bepaald door de eigen inkomsten en
                    woonsituatie van het (klein)kind.
                </li>
                <li class="list">De uitkeringen eindigen alleen bij het overlijden van het (klein)kind.
                </li>
                <div class="space10"></div>
                De premies kun je ook betalen voor een (klein)kind dat op het tijdstip van de premiebetaling (nog) niet
                invalide is, maar, gelet op de medische prognose, wel invalide zal zijn op de datum waarop de
                uitkeringen ingaan.
            </div>
        </div>
    </div>

</div>

